import { useEffect, useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import "./styles/app.scss";
import "./styles/components.scss";
import "./styles/landing-page.scss";
import Signup from './pages/signup';
import CalendarPage from './components/calendar';
import ErrorPage from './pages/error';
import Header from './components/header';
import Dashboard from './pages/student/student-dashboard';
import RemoveStudent from './pages/teacher/removestudent';
import EditStudent from './pages/teacher/edit-student';
import TeacherForm from './pages/admin/add-teacher';
import Updatemarks from './pages/teacher/upadte-student-marks';
import CheckAssignment from './pages/teacher/check-assignment';

import StudentForm from './pages/teacher/add-student';
import Assignment from './pages/teacher/add-assignment';
import UpdateSessionals from './pages/teacher/update-sessionals';
import Sessionals from './pages/student/check-sessionals';
import Studentcheckatt from './pages/student/view-student-attendence';
import CheckFinalMarks from './pages/student/check-final-marks';
import AddAttendence from './pages/teacher/student-update-attendence';
import SubmitAssignment from './pages/student/submit-assignment';
import TeacherDashboard from './pages/teacher/teacher-dashboard';
import MyClasses from './pages/teacher/my-classes';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { InstitutionProvider } from './context/InstitutionContext';
import Preloader from './components/preloader';
import HomePage from './pages/home';
import SaaSLogin from './pages/saas-login';
import InstitutionRegistration from './pages/institution-registration';
import InstitutionAdminDashboard from './pages/admin/institution-admin-dashboard';
import AddBranch from './pages/admin/add-branch';
import AddClass from './pages/admin/add-class';
import AddUser from './pages/admin/add-user';
import SuperAdminDashboard from './pages/admin/super-admin-dashboard';
import SubjectManagement from './pages/admin/subject-management';
import ManageUsers from './pages/admin/manage-users';
import ManageStudents from './pages/admin/manage-students';
import AnalyticsDashboard from './pages/admin/analytics-dashboard';
import UploadDataDebug from './pages/UploadDataDebug';
import SeedDatabase from './pages/SeedDatabase';




function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check stored user on app load
    const storedUser = sessionStorage.getItem('logged_user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (error) {
        console.error('Failed to parse stored user:', error);
        sessionStorage.removeItem('logged_user');
      }
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <Preloader />;
  }

  return (
    <Router>
      <AuthProvider>
        <InstitutionProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={user ? <Navigate to={user.role === 'teacher' ? '/teacher-dashboard' : user.role === 'super_admin' ? '/super-admin-dashboard' : '/admin-dashboard'} /> : <SaaSLogin />} />
            <Route path="/signup" element={user ? <Navigate to={user.role === 'teacher' ? '/teacher-dashboard' : user.role === 'super_admin' ? '/super-admin-dashboard' : '/admin-dashboard'} /> : <Signup />} />
            <Route path="/upload-data" element={<UploadDataDebug />} />
            <Route path="/seed" element={<SeedDatabase />} />

            {/* SaaS Routes */}
            <Route path="/register-institution" element={<InstitutionRegistration />} />
            <Route path="/admin-dashboard" element={<ProtectedRoute requiredRole={['admin', 'principal']}><InstitutionAdminDashboard /></ProtectedRoute>} />
            <Route path="/add-branch" element={<ProtectedRoute requiredRole={['admin', 'principal']}><AddBranch /></ProtectedRoute>} />
            <Route path="/add-class" element={<ProtectedRoute requiredRole={['admin', 'principal']}><AddClass /></ProtectedRoute>} />
            <Route path="/add-user" element={<ProtectedRoute requiredRole={['admin', 'principal']}><AddUser /></ProtectedRoute>} />
            <Route path="/manage-users" element={<ProtectedRoute requiredRole={['admin', 'principal']}><ManageUsers /></ProtectedRoute>} />
            <Route path="/manage-students" element={<ProtectedRoute requiredRole={['admin', 'principal']}><ManageStudents /></ProtectedRoute>} />
            <Route path="/subject-management" element={<ProtectedRoute requiredRole={['admin', 'principal']}><SubjectManagement /></ProtectedRoute>} />
            <Route path="/analytics-dashboard" element={<ProtectedRoute requiredRole={['admin', 'principal']}><AnalyticsDashboard /></ProtectedRoute>} />
            <Route path="/super-admin-dashboard" element={<ProtectedRoute requiredRole="super_admin"><SuperAdminDashboard /></ProtectedRoute>} />

            {/* Error Routes */}
            <Route path="/error" element={<ErrorPage />} />
            <Route path="*" element={<Navigate replace to="/error" />} />

            {/* Student Routes - Protected */}
            <Route path="/dashboard" element={<ProtectedRoute requiredRole="student"><Dashboard /></ProtectedRoute>} />
            <Route path="/check-sessional" element={<ProtectedRoute requiredRole="student"><Sessionals /></ProtectedRoute>} />
            <Route path="/check-attendence" element={<ProtectedRoute requiredRole="student"><Studentcheckatt /></ProtectedRoute>} />
            <Route path="/checkmarks" element={<ProtectedRoute requiredRole="student"><CheckFinalMarks /></ProtectedRoute>} />
            <Route path="/submit-assignment" element={<ProtectedRoute requiredRole="student"><SubmitAssignment /></ProtectedRoute>} />

            {/* Teacher Routes - Protected */}
            <Route path="/teacher-dashboard" element={<ProtectedRoute requiredRole="teacher"><TeacherDashboard /></ProtectedRoute>} />
            <Route path="/my-classes" element={<ProtectedRoute requiredRole="teacher"><MyClasses /></ProtectedRoute>} />
            <Route path="/remove-student" element={<ProtectedRoute requiredRole="teacher"><RemoveStudent /></ProtectedRoute>} />
            <Route path="/edit-student" element={<ProtectedRoute requiredRole="teacher"><EditStudent /></ProtectedRoute>} />
            <Route path="/updatemarks" element={<ProtectedRoute requiredRole="teacher"><Updatemarks /></ProtectedRoute>} />
            <Route path="/check-assignment" element={<ProtectedRoute requiredRole="teacher"><CheckAssignment /></ProtectedRoute>} />
            <Route path="/studentform" element={<ProtectedRoute requiredRole="teacher"><StudentForm /></ProtectedRoute>} />
            <Route path="/assignment" element={<ProtectedRoute requiredRole="teacher"><Assignment /></ProtectedRoute>} />
            <Route path="/update-sessional" element={<ProtectedRoute requiredRole="teacher"><UpdateSessionals /></ProtectedRoute>} />
            <Route path="/addAttendence" element={<ProtectedRoute requiredRole="teacher"><AddAttendence /></ProtectedRoute>} />
            <Route path="/add-teacher" element={<ProtectedRoute requiredRole="teacher"><TeacherForm /></ProtectedRoute>} />

            {/* Additional Routes */}
            <Route path="/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
            <Route path="/header" element={<ProtectedRoute><Header /></ProtectedRoute>} />
          </Routes>
        </InstitutionProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;

